import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
  accountCancellation,
  accountReActivate,
  changePassword,
  createGuestUser,
  getBilling,
  getGuestUser,
  getTransactionDetail,
  GetUserById,
  isGuestOrPremiumUser,
  updateGuestUser,
  updateUser,
} from "./actions";
import Settings from "./component";
import { getAssessmentAttemptByUserId } from "../dashboard/actions";
import { getPlans } from "../plan/actions";

const mapStateToProps = ({ funnelStep }) => ({ funnelStep });

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      GetUserByIdConnect: GetUserById,
      ChangePasswordConnect: changePassword,
      AccountCancellationConnect: accountCancellation,
      GetTransactionDetailConnect: getTransactionDetail,
      GetBillingConnect: getBilling,
      UpdateUserConnect: updateUser,
      GetGuestUserConnect: getGuestUser,
      GuestUserChangesConnect: createGuestUser,
      UpdateGuestUserConnect: updateGuestUser,
      IsGuestOrPremiumUserConnect: isGuestOrPremiumUser,
      getAssessmentAttemptByUserIdConnect: getAssessmentAttemptByUserId,
      AccountReActivateConnect: accountReActivate,
      getPlansConnect: getPlans,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Settings);
